function Env() {

    return (
        <div>
            { process.env.NODE_ENV }
        </div>
    );
}

export default Env;